import side_nav_logo from '../../styles/images/braxo-full-logo.svg'
import { useLocation, Link } from 'react-router-dom'
import { useRef, useState } from 'react'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import BarChartIcon from '@mui/icons-material/BarChart'

const SideNav = () => {
  const contentEl = useRef() as React.MutableRefObject<HTMLInputElement>
  const [clicked, setClicked] = useState(-1)

  const location = useLocation()
  const pathname = location.pathname

  const menuItems = [
    { label: 'Reports', icon: <BarChartIcon className="w-4 h-4" />, path: '/reports' },
    { label: 'Office', icon: <BarChartIcon className="w-4 h-4" />, path: '/offices' },
    { label: 'Testimonials', icon: <BarChartIcon className="w-4 h-4" />, path: '/our-clients' },
    { label: 'Rentals', icon: <BarChartIcon className="w-4 h-4" />, path: '/rentals' },
    { label: 'Snacks & Drinks Menu', icon: <BarChartIcon className="w-4 h-4" />, path: '/menu' },
    { label: 'Events', icon: <BarChartIcon className="w-4 h-4" />, path: '/events' },
    { label: 'Q&A', icon: <BarChartIcon className="w-4 h-4" />, path: '/questions-and-answers' },
    { label: 'Office Options', icon: <BarChartIcon className="w-4 h-4" />, path: '/office-options' },
    { label: 'Email Feedback', icon: <BarChartIcon className="w-4 h-4" />, path: '/feedback' },
    { label: 'Users', icon: <BarChartIcon className="w-4 h-4" />, path: '/users' },
    { label: 'Payments', icon: <BarChartIcon className="w-4 h-4" />, path: '/payments' },
    {
      label: 'Settings',
      children: [
        { label: 'Specifications', path: '/specifications' },
        { label: 'Membership Plans', path: '/membership-plans' },
      ],
    },
  ]

  const handleToggle = (id: number) => {
    setClicked(clicked === id ? -1 : id)
  }

  return (
    <div className="fixed inset-y-0 left-0 w-64 bg-white flex flex-col z-40">
      <div className="px-5 pt-5 border-b shrink-0">
        <img src={side_nav_logo} className="w-full" alt="Braxo Hub Logo" />
      </div>

      <div className="flex-1 overflow-y-auto px-3 pb-4 space-y-1">
        {menuItems.map((menuItem, id) => {
          if (!menuItem.children) {
            return (
              <Link
                key={id}
                to={menuItem.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition
                ${pathname.includes(menuItem.path)
                    ? 'bg-indigo-50 text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'}`}
              >
                {menuItem.icon}
                <span>{menuItem.label}</span>
              </Link>
            )
          }

          return (
            <div key={id}>
              <button
                onClick={() => handleToggle(id)}
                className="w-full flex justify-between items-center px-4 py-3 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-100"
              >
                <span>{menuItem.label}</span>
                <KeyboardArrowDownOutlinedIcon className={`transition ${clicked === id && 'rotate-180'}`} />
              </button>

              <div
                ref={contentEl}
                style={clicked === id ? { height: 'auto' } : { height: '0px' }}
                className="overflow-hidden transition-all duration-300"
              >
                <div className="pl-4 mt-2 space-y-1">
                  {menuItem.children.map((el, childIndex) => (
                    <Link
                      key={childIndex}
                      to={el.path}
                      className={`block px-4 py-2 rounded-lg text-sm transition
                      ${pathname.includes(el.path)
                          ? 'bg-indigo-50 text-indigo-700'
                          : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                      {el.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SideNav
